import { routePaths } from "@/App";
import { useToast } from "@/components/ui/use-toast";
import { useWebSocketEvent } from "@/libs/api/hooks/useWebSocketEvent";
import { useDriver } from "@/libs/auth/data/driver";
import { getLogger } from "@/utils/logger";
import { useNavigate } from "react-router";
import { Tour } from "../types";

const log = getLogger("app:libs:tours:useTourEvents");

export function useTourEvents(tours: Tour[], setContext: any) {
  const { driver } = useDriver();
  const { toast } = useToast();
  const navigate = useNavigate();

  useWebSocketEvent("tourChange", ({ tour, type }) => {
    if (!driver || !tour) {
      return;
    }

    const internalTour: Tour = {
      id: tour.id,
      name: tour.name,
      state: tour.state,
      date: tour.scheduledStart ?? new Date(),
    };

    const isDriverAssigned = tour.driver === driver.id;
    const isTourInList = tours.some((_tour) => _tour.id === tour.id);

    if (type === "optimized" && isDriverAssigned && !isTourInList) {
      log("New tour was added to the list");

      toast({
        title: "Neue Tour hinzugefügt",
        description: "Dir wurde gerade eine neue tour zugewiesen.",
        variant: "info",
      });

      setContext({
        type: "add",
        newTour: internalTour,
      });

      return;
    }

    if (type === "driverChanged" && isTourInList && !isDriverAssigned) {
      log("Tour was unassigned from the current driver");

      if (location.pathname.includes(tour.id)) {
        navigate(routePaths.home);
      }

      toast({
        title: "Tour zurückgezogen",
        description:
          "Dir wurde eine Tour entzogen. Du kannst sie nun nicht mehr sehen.",
        variant: "info",
      });

      setContext({
        type: "remove",
        tourId: tour.id,
      });
    }
  });
}
